// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { assignShipToAddressModalStyles } from "@eisinc/Overrides/Widgets/UserSetup/AssignShipToAddressModal";
import { color, modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

assignShipToAddressModalStyles.tableHeader = {
    css: css`
        display: flex;
    `,
};

assignShipToAddressModalStyles.shipToContainer = {
    gap: 20,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        padding: 1rem 0;
        display: flex;
        align-items: center;
    `,
};

assignShipToAddressModalStyles.buttonsWrapper = {
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        margin-top: 16px;
    `,
};

assignShipToAddressModalStyles.cancelButton = { ...modalButtonsActionStyles.cancelButton };

assignShipToAddressModalStyles.saveButton = { ...modalButtonsActionStyles.submitButton };

assignShipToAddressModalStyles.pagination = {
    cssOverrides: {
        pagination: css`
            margin-top: 20px;
        `,
    },
};

assignShipToAddressModalStyles.dataTableWrapper = {
    css: css`
        overflow: auto;
    `,
};
